module.exports = __webpack_public_path__ + "img/hood.ead89ce6.png";